/* Premium soft-tint system — matches the main app theme:
   pastel background + deep-tone icon + hairline ring. */

export const TONES = {
  blue: { tile: 'bg-[#EEF2FF] text-[#375AE7] ring-1 ring-[#E0E7FF]' },
  violet: { tile: 'bg-[#F5F3FF] text-[#6D28D9] ring-1 ring-[#EDE9FE]' },
  green: { tile: 'bg-[#F0FDF4] text-[#16A34A] ring-1 ring-[#BBF7D0]' },
  amber: { tile: 'bg-[#FFFBEB] text-[#B45309] ring-1 ring-[#FDE68A]' },
  rose: { tile: 'bg-[#FFF1F2] text-[#BE123C] ring-1 ring-[#FECDD3]' },
  cyan: { tile: 'bg-[#ECFEFF] text-[#0E7490] ring-1 ring-[#CFFAFE]' },
  slate: { tile: 'bg-[#F8FAFC] text-[#475569] ring-1 ring-[#E2E8F0]' },
};

/* Same monogram palette as the main app's getAvatarStyle */
export const AVATAR_STYLES = [
  'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
  'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
  'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
  'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
  'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
];

export const avatarStyle = (name = '') =>
  AVATAR_STYLES[(name.charCodeAt(0) || 0) % AVATAR_STYLES.length];

export const initials = (name = '') =>
  name
    .trim()
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
